import { Injectable, inject } from '@angular/core';
import { NextVersionService } from '@app/next/services/next-version.service';
import { isNotNullish } from '@fmnts/core';
import { FundraiserStore } from '@formunauts/next/fundraiser/data-access';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatLatestFrom } from '@ngrx/operators';
import { filter, map } from 'rxjs';
import {
  NextLocationApiActions,
  NextLocationDetailPageActions,
  NextLocationListPageActions,
} from './next-locations.actions';

/**
 * Bridges the new frontend and the old frontend regarding the current location.
 */
@Injectable()
export class NextLocationsPageEffects {
  private readonly actions$ = inject(Actions);
  private readonly fundraiserStore = inject(FundraiserStore);
  private readonly appVersion = inject(NextVersionService);

  checkInLocation$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(
        NextLocationDetailPageActions.checkIn,
        NextLocationListPageActions.checkIn,
      ),
      concatLatestFrom((action) => this.fundraiserStore.self$),
      filter(([_, fundraiser]) => isNotNullish(fundraiser)),
      map(([{ locationId, timestamp }, fundraiser]) =>
        NextLocationApiActions.checkIn.request({
          checkIn: {
            location: locationId,
            createtime: timestamp,
            fundraiser: fundraiser.id,
            versionNumber: this.appVersion.dataTag,
          },
        }),
      ),
    );
  });
}
